import React from 'react';
import styled from 'styled-components';
import {navigate, Link} from 'gatsby';
import * as Ant from 'antd';
import {useOutlet} from 'reconnect.js';
import {Menu} from '@styled-icons/boxicons-regular';
import {Cart} from '@styled-icons/bootstrap/Cart';
import * as AppActions from '../../AppActions';
import SearchArticleInput from '../SearchArticleInput';

const F = AppActions.F;

function SiteNavBar(props) {
  const [dimension] = useOutlet('dimension');
  const [navbarConfig] = useOutlet('navbarConfig');
  const [showDrawer, setShowDrawer] = React.useState(false);
  const {pathname} = props.location;
  const isBreakpoint = dimension.innerWidth >= 1400;
  const isMoreItems =
    navbarConfig &&
    Array.isArray(navbarConfig.entries) &&
    navbarConfig.entries.length > 8;

  return (
    <>
      <Wrapper>
        <div
          className="nav-content"
          style={{width: '100%', position: 'relative'}}>
          <SearchArticleInput
            isBreakpoint={isBreakpoint}
            isMoreItems={isMoreItems}
          />

          {isBreakpoint && !isMoreItems ? (
            <div style={{display: 'flex', margin: '0 auto'}}>
              {navbarConfig &&
                Array.isArray(navbarConfig.entries) &&
                navbarConfig.entries.length > 0 &&
                navbarConfig.entries
                  .slice(0, Math.ceil(navbarConfig.entries.length / 2))
                  .map((it, idx) => {
                    let selected = props.path.indexOf(it.path) > -1;
                    return (
                      <Link
                        to={it.path}
                        className="nav-link"
                        key={idx}
                        style={{
                          color: selected ? '#b02b4c' : '#434343',
                        }}>
                        {F(it, 'name')}
                      </Link>
                    );
                  })}

              <h2 style={{cursor: 'pointer'}} onClick={() => navigate('/')}>
                <img
                  src="/images/NavLogo.png"
                  alt="Logo"
                  style={{width: 120, height: 63, objectFit: 'contain'}}
                />
              </h2>

              {navbarConfig &&
                Array.isArray(navbarConfig.entries) &&
                navbarConfig.entries.length > 0 &&
                navbarConfig.entries
                  .slice(
                    Math.ceil(navbarConfig.entries.length / 2),
                    navbarConfig.entries.length,
                  )
                  .map((it, idx) => {
                    let selected = props.path.indexOf(it.path) > -1;
                    return (
                      <Link
                        to={it.path}
                        className="nav-link"
                        key={idx}
                        style={{
                          color: selected ? '#b02b4c' : '#434343',
                        }}>
                        {F(it, 'name')}
                      </Link>
                    );
                  })}

              <Link
                to="https://www.shopping-v.com"
                className="nav-link"
                style={{minWidth: 'auto'}}>
                <Cart size={20} color="var(--primaryColor)" />
              </Link>
            </div>
          ) : (
            <div
              className="row"
              style={{
                width: '100%',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}>
              <h2 onClick={() => navigate('/')}>
                <img
                  src="/images/NavLogo.png"
                  alt="Logo"
                  style={{height: 50, objectFit: 'contain'}}
                />
              </h2>
              <div
                onClick={() => setShowDrawer(true)}
                style={{cursor: 'pointer'}}>
                <Menu size={30} />
              </div>
            </div>
          )}
        </div>
      </Wrapper>
      <Ant.Drawer
        placement="right"
        closable={false}
        onClose={() => setShowDrawer(false)}
        open={showDrawer}
        drawerStyle={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <img
          src="/images/NavLogo.png"
          alt="Logo"
          style={{width: 154, height: 50, objectFit: 'contain'}}
        />
        {navbarConfig &&
          Array.isArray(navbarConfig.entries) &&
          navbarConfig.entries.length > 0 &&
          navbarConfig.entries.map((it, idx) => {
            let selected = props.path.indexOf(it.path) > -1;
            return (
              <div
                onClick={() => setShowDrawer(false)}
                style={{paddingTop: 40, textAlign: 'center'}}>
                <Link
                  to={it.path}
                  className="nav-link"
                  key={idx}
                  style={{color: selected ? '#b02b4c' : '#434343'}}>
                  {F(it, 'name')}
                </Link>
              </div>
            );
          })}
      </Ant.Drawer>
      <Placeholder />
    </>
  );
}

const Wrapper = styled.div`
  display: flex;
  position: fixed;
  flex-direction: row;
  justify-content: center;
  background-color: white;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: var(--topNavBarHeight);
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: 200ms;
  z-index: 1;

  & > .nav-content {
    height: 100%;
    max-width: var(--contentMaxWith);
    padding: 0 15px;
    display: flex;
    align-items: center;

    & .nav-link {
      line-height: 30px;
      font-size: var(--contentTextSize);
      color: var(--contentTextColor);
      letter-spacing: var(--contentTextLetterSpacing);
      padding: 10px;
      min-width: 80px;

      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Noto Serif TC';
    }
  }
`;

const Placeholder = styled.div`
  position: static;
  height: var(--topNavBarHeight);
`;

export default SiteNavBar;
